import identify from './identify'
import format from './format'

const cardFlag = {
  identify,
  format,
}

export default cardFlag
